module.exports = __webpack_public_path__ + "static/media/arrow-right-signIn.ecbe294c.svg";